import React, { useState, useEffect } from 'react';
import { 
    Select, 
    MenuItem, 
    Button, 
    Box,
    IconButton,
    Tooltip,
    Chip
} from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import { Operators } from '../../../metadata';
import { simplifyHeader } from '../../../methods';

const FilterChildItem = ({ 
    filter, 
    index, 
    array, 
    value, 
    setFilters, 
    currentRow, 
    parentArray, 
    parentIndex 
}) => {
    const [operatorValue, setOperatorValue] = useState(filter?.operator || '=');

    // Sync local state with filter prop when it changes
    useEffect(() => {
        if (filter?.operator && filter.operator !== operatorValue) {
            console.log('Syncing operator value:', filter.operator);
            setOperatorValue(filter.operator);
        }
    }, [filter?.operator, operatorValue]);

    const handleOperatorChange = (val) => {
        console.log('=== CHANGING OPERATOR ===');
        console.log('New operator value:', val);
        console.log('Filter to update:', filter);
        console.log('Filter ID:', filter.id);
        console.log('Current row:', currentRow);
        console.log('Current row ID:', currentRow.id);
        
        setOperatorValue(val);
        
        setFilters(prevState => {
            console.log('Previous filters state:', prevState);
            
            return prevState.map(category => {
                console.log('Processing category:', category.category, 'Key:', category.key);
                
                // Find the category that contains our parent row
                const hasMatchingRow = category.rows?.some(row => row.id === currentRow.id);
                console.log('Has matching row in category:', hasMatchingRow);
                
                if (hasMatchingRow) {
                    console.log('Found matching category, updating rows...');
                    
                    const updatedRows = category.rows.map(row => {
                        console.log('Checking row ID:', row.id, 'against currentRow ID:', currentRow.id);
                        
                        if (row.id === currentRow.id) {
                            console.log('Found matching row, processing sub-filters...');
                            console.log('Current sub-filters:', row.rows);
                            
                            // Update the operator for the specific sub-filter
                            const updatedSubFilters = row.rows?.map(subFilterGroup => {
                                console.log('Processing sub-filter group:', subFilterGroup);
                                const updatedGroup = { ...subFilterGroup };
                                
                                // For each property in the group
                                Object.keys(updatedGroup).forEach(key => {
                                    console.log('Processing key:', key);
                                    
                                    if (Array.isArray(updatedGroup[key])) {
                                        console.log('Found array for key:', key, 'with items:', updatedGroup[key]);
                                        
                                        updatedGroup[key] = updatedGroup[key].map(item => {
                                            console.log('Checking item:', item);
                                            console.log('Item ID:', item.id, 'Filter ID:', filter.id);
                                            
                                            // Match by ID first (most reliable)
                                            const matchById = item.id && filter.id && item.id === filter.id;
                                            
                                            // Fallback: match by unique combination of properties
                                            const matchByProps = !matchById && 
                                                item.value === filter.value && 
                                                item.friendlyName === filter.friendlyName &&
                                                item.key === filter.key &&
                                                item.field === filter.field;
                                            
                                            const isMatch = matchById || matchByProps;
                                            
                                            console.log('Match by ID:', matchById);
                                            console.log('Match by props:', matchByProps);
                                            console.log('Is match:', isMatch);
                                            
                                            if (isMatch) {
                                                console.log('Updating operator from', item.operator, 'to', val);
                                                return {
                                                    ...item,
                                                    operator: val
                                                };
                                            }
                                            
                                            return item;
                                        });
                                        
                                        console.log('Updated items for key:', key, updatedGroup[key]);
                                    }
                                });
                                
                                return updatedGroup;
                            });
                            
                            console.log('Final updated sub-filters:', updatedSubFilters);
                            
                            return {
                                ...row,
                                rows: updatedSubFilters
                            };
                        }
                        return row;
                    });
                    
                    return {
                        ...category,
                        rows: updatedRows
                    };
                }
                return category;
            });
        });
    }

    const handleDeleteSubFilter = () => {
        console.log('=== DELETING SUB-FILTER ===');
        console.log('Filter to delete:', filter);
        console.log('Filter ID:', filter.id);
        console.log('Current row:', currentRow);
        console.log('Current row ID:', currentRow.id);
        
        setFilters(prevState => {
            console.log('Previous state:', prevState);
            
            return prevState.map(category => {
                console.log('Processing category:', category.id, category.category);
                
                // Find the category that contains our parent row
                const hasMatchingRow = category.rows?.some(row => row.id === currentRow.id);
                console.log('Has matching row in category:', hasMatchingRow);
                
                if (hasMatchingRow) {
                    console.log('Found matching category:', category.category);
                    
                    // Update the specific row that contains this sub-filter
                    const updatedRows = category.rows.map(row => {
                        console.log('Checking row:', row.id, 'against currentRow:', currentRow.id);
                        
                        if (row.id === currentRow.id) {
                            console.log('Found matching row, current sub-filters:', row.rows);
                            
                            // Filter out sub-filters from this specific category
                            const updatedSubFilters = row.rows?.map(subFilterGroup => {
                                console.log('Processing sub-filter group:', subFilterGroup);
                                const updatedGroup = { ...subFilterGroup };
                                
                                // For each property in the group (e.g., ICD_TYPE, DATE_ACTIVE)
                                Object.keys(updatedGroup).forEach(key => {
                                    console.log('Processing key:', key, 'with items:', updatedGroup[key]);
                                    
                                    if (Array.isArray(updatedGroup[key])) {
                                        const originalLength = updatedGroup[key].length;
                                        console.log(`Original ${key} length:`, originalLength);
                                        
                                        // Remove the specific filter by ID (primary) or by value+friendlyName (fallback)
                                        updatedGroup[key] = updatedGroup[key].filter(item => {
                                            console.log('Checking item for deletion:', item);
                                            console.log('Item ID:', item.id, 'Filter ID:', filter.id);
                                            
                                            const matchById = item.id && filter.id && item.id === filter.id;
                                            const matchByValue = !matchById && 
                                                item.value === filter.value && 
                                                item.friendlyName === filter.friendlyName &&
                                                item.key === filter.key;
                                            
                                            const shouldRemove = matchById || matchByValue;
                                            
                                            console.log('Match by ID:', matchById);
                                            console.log('Match by value:', matchByValue);
                                            console.log('Should remove:', shouldRemove);
                                            
                                            if (shouldRemove) {
                                                console.log(`Removing filter from ${key}:`, item);
                                            }
                                            
                                            return !shouldRemove;
                                        });
                                        
                                        console.log(`Updated ${key}: ${originalLength} -> ${updatedGroup[key].length} items`);
                                        
                                        // If the array is empty, remove the entire group
                                        if (updatedGroup[key].length === 0) {
                                            console.log(`Removing empty group: ${key}`);
                                            delete updatedGroup[key];
                                        }
                                    }
                                });
                                
                                console.log('Updated group after processing:', updatedGroup);
                                
                                // Only return the group if it still has properties
                                return Object.keys(updatedGroup).length > 0 ? updatedGroup : null;
                            }).filter(Boolean); // Remove null entries
                            
                            console.log('Final updated sub-filters:', updatedSubFilters);
                            
                            return {
                                ...row,
                                rows: updatedSubFilters
                            };
                        }
                        return row;
                    });
                    
                    return {
                        ...category,
                        rows: updatedRows
                    };
                }
                return category;
            });
        });
    };

    const SelectOperators = () => {
        const operators = filter.key === 'BIRTH_YEAR'
            ? Operators.birthYear
            : filter.dataType === 'TEXT'
                ? Operators.text
                : Operators.number;
        if (filter.dataType === "DATE" && filter.key !== "BIRTH_YEAR" && filter.operator === "between") return <span>{filter.operator}</span>;
        
        console.log('=== SELECT OPERATORS RENDER ===');
        console.log('Filter:', filter);
        console.log('Filter operator:', filter?.operator);
        console.log('Operator value state:', operatorValue);
        console.log('Available operators:', operators);
        console.log('Filter data type:', filter.dataType);
        
        return (
            <Select
                id="field-select"
                label="Field"
                onChange={(e) => {
                    console.log('Operator changed in Select:', e.target.value);
                    handleOperatorChange(e.target.value);
                }}
                variant="standard"
                size="small"
                value={operatorValue} // Use local state that syncs with filter
                sx={{ fontSize: '0.75rem' }}
            >
                {operators.map(({ name, label }) => {
                    return <MenuItem value={name} key={name} sx={{ fontSize: '0.75rem' }}>{label}</MenuItem>;
                })}
            </Select>
        );
    }

    const showValue = (value, filter) => {
        if (filter.dataType === 'DATE') {
            if (filter.key === 'BIRTH_YEAR') {
                if (filter.operator === 'between') {
                    const dates = value.split(',');
                    if (dates.length === 2) {
                        return <span>{dates[0].split('-')[0]} to {dates[1].split('-')[0]}</span>;
                    }
                }
                return <span>{value.split('-')[0]}</span>;
            }

            if (filter.operator === 'between') {
                const dates = value.split(',');
                if (dates.length === 2) {
                    const formattedDates = dates.map(date => {
                        const [year, month, day] = date.split('-');
                        return `${month}-${day}-${year}`;
                    });
                    return <span>{formattedDates.join(' to ')}</span>
                }
            }
            else {
                // Split the date string into parts
                const [year, month, day] = value.split('-').map(part => parseInt(part, 10));

                // Create a new date using the local time zone
                const date = new Date(year, month - 1, day);

                // Format the date as MM-DD-YYYY
                const formattedDate = `${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}-${year}`;
                return <span>{formattedDate}</span>;
            }
        }
        return <span>{value}</span>;
    }

    const childFilterItem = () => {
        return (
            <Box 
                sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: 1,
                    padding: '4px 8px',
                    backgroundColor: 'rgba(59, 130, 246, 0.05)',
                    borderRadius: '6px',
                    border: '1px solid rgba(59, 130, 246, 0.2)',
                    margin: '2px 0'
                }}
            >
                <Box sx={{ flex: 1, fontSize: '0.75rem' }}>
                    {simplifyHeader(filter.friendlyName)} {SelectOperators()} {showValue(value, filter)}
                </Box>
                <Tooltip title="Remove sub-filter">
                    <IconButton 
                        size="small" 
                        onClick={handleDeleteSubFilter}
                        sx={{ 
                            padding: '2px',
                            color: 'error.main',
                            '&:hover': {
                                backgroundColor: 'error.light',
                                color: 'white'
                            }
                        }}
                    >
                        <ClearIcon sx={{ fontSize: '14px' }} />
                    </IconButton>
                </Tooltip>
            </Box>
        );
    }

    return (
        <>
            <li 
                key={filter.key} 
                className="child-filter-list-item"
                style={{ listStyle: 'none', margin: '2px 0' }}
            >
                {childFilterItem()}
            </li>
            {array[index + 1] && (
                <li style={{ listStyle: 'none', textAlign: 'center', margin: '4px 0' }}>
                    <Chip 
                        label="OR" 
                        size="small" 
                        variant="outlined"
                        sx={{ 
                            fontSize: '0.625rem',
                            height: '20px',
                            backgroundColor: 'background.paper',
                            fontWeight: 500
                        }}
                    />
                </li>
            )}
        </>
    )
}

export default FilterChildItem